<template>
    <div id="app" class="page">
        <div class="main">
            <sidebar></sidebar>
            <main id="main-content">
                <header1></header1>
                <router-view />
            </main>
        </div>
    </div>
</template>

<script>
import header1 from './header1.vue'
import pageheader from './pageheader.vue'

import sidebar from './sidebar.vue'
import footer1 from './footer1.vue'
export default {
    name: 'AppLayout',
    components: {
        header1,
        pageheader,
        sidebar,
        footer1
    }
}
</script>
<style>

</style>
